<template>
    <div class="dropdown-container">
        <select class="dropdown-select" @change="changeSubscription($event)">
            <option :value="'all'">
                {{ $t('allOrganizations') }}
            </option>
            <option v-for="item in data" :key="item.id" :value="item.id">
                {{ item.organizationName }}
            </option>
        </select>
        <span class="dropdown-icon">
            <i class="fas fa-angle-down"></i>
        </span>
    </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import { Subscription, SubscriptionGetResponse } from './Subscription.model';
import agent, { masterServiceBaseURL } from '@/services/agent';

let _data: Subscription[] = [];

export default defineComponent({
    emits: ['onSubscription'],
    setup(props, ctx) {
        const data = ref(_data);

        onMounted(() => {
            loadSubscription();
        });

        function loadSubscription() {
            agent.post<SubscriptionGetResponse>(`${masterServiceBaseURL}v1/subscription/getsubscription`, {}).then((response) => {
                if (response.result) {
                    data.value = response.result.result;
                }
            }).catch(() => { });
        }

        function changeSubscription(event: any) {
            ctx.emit('onSubscription', event.target.value);
        }

        return {
            props, ctx, data, loadSubscription, changeSubscription
        }
    }
})
</script>